import patrollerDecRows from './patrollerDecData.json';
import patrollerFebRows from './patrollerFebData.json';

export const PATROLLER_MONTH_DATA = {
  "Dec'25": {
    month: "Dec'25",
    sourceLabel: 'Patroller Dump',
    rows: patrollerDecRows,
  },
  "Feb'26": {
    month: "Feb'26",
    sourceLabel: 'Patrolling Dump',
    rows: patrollerFebRows,
  },
};

export const PATROLLER_RATE_OPTIONS = [
  { value: 'ALL', label: 'All 1.8A Rates' },
  { value: 'zero', label: '0% (Never compliant)' },
  { value: 'low', label: 'Low (<50%)' },
  { value: 'mid', label: 'Mid (50-80%)' },
  { value: 'high', label: 'High (>80%)' },
];

export const PATROLLER_COVERAGE_OPTIONS = [
  { value: 'ALL', label: 'All 1.8B Coverage' },
  { value: 'zero', label: '0% (No patrol)' },
  { value: 'low', label: 'Low (<25%)' },
  { value: 'mid', label: 'Mid (25-75%)' },
  { value: 'good', label: 'High (>75%)' },
];

export const PATROLLER_TABLE_COLUMNS = [
  { key: 'circle', label: 'Circle', align: 'left', group: 'Identity' },
  { key: 'mp', label: 'MP', align: 'left', group: 'Identity' },
  { key: 'nw_type', label: 'NW Type', align: 'left', group: 'Identity' },
  { key: 'name', label: 'Patroller Name', align: 'left', group: 'Identity' },
  { key: 'code', label: 'Emp Code', align: 'left', group: 'Identity' },
  { key: 'j', label: 'Compliant Days', align: 'center', group: '1.8A App Compliance' },
  { key: 'aa', label: 'Total Days', align: 'center', group: '1.8A App Compliance' },
  { key: 'ar', label: '1.8A Rate', align: 'left', group: '1.8A App Compliance' },
  { key: 'u', label: 'Assigned KM', align: 'right', group: '1.8B Route Coverage' },
  { key: 'k', label: '1.8B Scope', align: 'right', group: '1.8B Route Coverage' },
  { key: 'z', label: 'Patrol KM', align: 'right', group: '1.8B Route Coverage' },
  { key: 'cv', label: '1.8B Coverage', align: 'left', group: '1.8B Route Coverage' },
  { key: 'sp', label: 'Assigned', align: 'center', group: 'Spans' },
  { key: 'as_', label: 'Active', align: 'center', group: 'Spans' },
];

export function formatPatrollerCount(value) {
  return Number(value || 0).toLocaleString('en-IN');
}

export function formatPatrollerKm(value, digits = 2) {
  return Number(value || 0).toLocaleString('en-IN', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function formatPatrollerPercent(value) {
  if (value === null || value === undefined) return '-';
  if (value > 100) return '>100%';
  return `${Number(value).toFixed(1)}%`;
}

export function patrollerRateTone(value) {
  if (value === 0) return 'slate';
  if (value >= 80) return 'green';
  if (value >= 50) return 'olive';
  return 'red';
}

export function patrollerCoverageTone(value) {
  if (value === 0) return 'slate';
  if (value >= 100) return 'green';
  if (value >= 75) return 'olive';
  if (value >= 25) return 'amber';
  return 'red';
}

export function matchesPatrollerRateFilter(value, filter) {
  if (filter === 'ALL') return true;
  if (filter === 'zero') return value === 0;
  if (filter === 'low') return value > 0 && value < 50;
  if (filter === 'mid') return value >= 50 && value <= 80;
  if (filter === 'high') return value > 80;
  return true;
}

export function matchesPatrollerCoverageFilter(value, filter) {
  if (filter === 'ALL') return true;
  if (filter === 'zero') return value === 0;
  if (filter === 'low') return value > 0 && value < 25;
  if (filter === 'mid') return value >= 25 && value <= 75;
  if (filter === 'good') return value > 75;
  return true;
}

export function buildPatrollerSummary(rows) {
  const totals = rows.reduce((accumulator, row) => {
    accumulator.j += row.j;
    accumulator.aa += row.aa;
    accumulator.u += row.u;
    accumulator.k += row.k;
    accumulator.z += row.z;
    accumulator.sp += row.sp;
    accumulator.as_ += row.as_;
    accumulator.zeroRate += row.ar === 0 ? 1 : 0;
    accumulator.zeroCoverage += row.cv === 0 ? 1 : 0;
    return accumulator;
  }, {
    j: 0,
    aa: 0,
    u: 0,
    k: 0,
    z: 0,
    sp: 0,
    as_: 0,
    zeroRate: 0,
    zeroCoverage: 0,
  });

  const circleCount = new Set(rows.map((row) => row.circle)).size;
  const mpCount = new Set(rows.map((row) => row.mp)).size;
  const appRate = totals.aa ? (totals.j / totals.aa) * 100 : 0;
  const coverageRate = totals.k ? (totals.z / totals.k) * 100 : 0;
  const activeSpanRate = totals.sp ? (totals.as_ / totals.sp) * 100 : 0;

  return {
    totalPatrollers: rows.length,
    circleCount,
    mpCount,
    totals,
    appRate,
    coverageRate,
    activeSpanRate,
  };
}
